/* eslint-disable */
<template>
  <!-- eslint-disable max-len -->
  <div>
    <svg
      class="ms-1"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-for="item in fullStar"
      :key="item"
      v-show="fullStar"
    >
      <g clip-path="url(#clip0_552_7922)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.39938 1.85429C8.09062 1.23383 7.60809 0.77639 6.99792 0.77639C6.38846 0.77639 5.90435 1.23305 5.59275 1.85304L4.56568 3.90719L4.56409 3.91041C4.53327 3.97332 4.4596 4.06286 4.3486 4.14516C4.23797 4.22719 4.13066 4.27207 4.06187 4.28391L2.20195 4.59293C1.53106 4.70474 0.967621 5.03124 0.785015 5.60309C0.602536 6.17453 0.87171 6.76714 1.3518 7.24722L2.79846 8.69389C2.8554 8.75082 2.91919 8.8581 2.9592 8.99781C2.99896 9.13676 3.00232 9.2627 2.9845 9.34349L2.98425 9.34466L2.57076 11.1326C2.39835 11.8776 2.45815 12.6173 2.98849 13.0043C3.5185 13.391 4.24161 13.2233 4.90027 12.8324L6.64116 11.8018L6.64226 11.8012C6.72055 11.756 6.84952 11.7212 7.00084 11.7212C7.15326 11.7212 7.27961 11.7565 7.35311 11.8001L9.09746 12.8326C9.75691 13.2222 10.4809 13.3929 11.0108 13.0066C11.5416 12.6197 11.5985 11.8786 11.4266 11.1329L11.0131 9.34466L11.0128 9.34349C10.995 9.2627 10.9984 9.13676 11.0381 8.99781C11.0781 8.8581 11.1419 8.75082 11.1989 8.69389L12.6445 7.24828C13.1276 6.76819 13.3981 6.17453 13.2142 5.6023C13.0305 5.03081 12.466 4.70471 11.7956 4.59297L9.93477 4.2838L8.39938 1.85429Z"
          fill="#FFD66D"
        />
      </g>
      <defs>
        <clipPath id="clip0_552_7922">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      class="ms-1"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="halfStar"
    >
      <g clip-path="url(#clip0_552_6200)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.37456 2.24596C6.37461 2.24585 6.3745 2.24608 6.37456 2.24596L5.34901 4.29703C5.23973 4.51919 5.0572 4.70901 4.86974 4.84801C4.68173 4.9874 4.44812 5.10583 4.20772 5.14665L4.20618 5.14691L2.34557 5.45604C2.34564 5.45602 2.34549 5.45605 2.34557 5.45604C1.82663 5.54257 1.65758 5.74695 1.61853 5.86925C1.57934 5.99198 1.59892 6.25688 1.9705 6.62846L3.41717 8.07513C3.60523 8.26319 3.73102 8.51467 3.80039 8.75699C3.86982 8.99954 3.89578 9.27843 3.83805 9.53603L3.8374 9.53889L3.42322 11.3297C3.26898 11.9963 3.425 12.2396 3.50422 12.2974C3.5838 12.3555 3.86401 12.4299 4.45369 12.0799L6.20113 11.0455C6.44374 10.9043 6.7343 10.8461 7.00082 10.8461C7.26688 10.8461 7.55756 10.9042 7.799 11.0472C7.79894 11.0472 7.79906 11.0472 7.799 11.0472L9.54281 12.0795C9.5427 12.0794 9.54293 12.0795 9.54281 12.0795C10.1373 12.4305 10.4172 12.3565 10.4954 12.2995C10.5728 12.2431 10.7288 12.0013 10.574 11.3294L10.1592 9.53603C10.1015 9.27843 10.1275 8.99954 10.1969 8.75699C10.2663 8.51467 10.392 8.26319 10.5801 8.07513L12.0268 6.62846L12.0278 6.62741C12.4018 6.25594 12.4203 5.99175 12.3812 5.87001C12.3418 5.74738 12.1713 5.54268 11.6519 5.45607C11.652 5.45609 11.6519 5.45606 11.6519 5.45607L9.79108 5.1469C9.54824 5.10643 9.31281 4.98845 9.12328 4.84861C8.93451 4.70935 8.75181 4.51934 8.64244 4.29706L7.61606 2.24433C7.3706 1.75081 7.12116 1.65137 6.99791 1.65137C6.87389 1.65137 6.62288 1.75207 6.37456 2.24596ZM8.39936 1.85427C8.09061 1.23381 7.60807 0.776367 6.99791 0.776367C6.38844 0.776367 5.90433 1.23303 5.59274 1.85301L4.56566 3.90717L4.56407 3.91038C4.53325 3.9733 4.45958 4.06284 4.34859 4.14514C4.23796 4.22716 4.13064 4.27205 4.06185 4.28389C4.06205 4.28386 4.06164 4.28393 4.06185 4.28389L2.20193 4.59291C1.53104 4.70472 0.967605 5.03122 0.784998 5.60307C0.60252 6.17451 0.871693 6.76712 1.35178 7.2472L2.79845 8.69387C2.85538 8.7508 2.91918 8.85808 2.95918 8.99779C2.99894 9.13674 3.0023 9.26268 2.98449 9.34347C2.9844 9.34388 2.98432 9.34429 2.98423 9.34464L2.57074 11.1326C2.57073 11.1326 2.57074 11.1325 2.57074 11.1326C2.39833 11.8776 2.45813 12.6173 2.98847 13.0042C3.51848 13.391 4.2416 13.2233 4.90025 12.8324L6.64114 11.8018C6.64155 11.8016 6.6419 11.8014 6.64225 11.8012C6.72053 11.756 6.84951 11.7211 7.00082 11.7211C7.15325 11.7211 7.2796 11.7565 7.3531 11.8001L9.09744 12.8326C9.7569 13.2222 10.4809 13.3929 11.0108 13.0066C11.5415 12.6196 11.5985 11.8786 11.4266 11.1329L11.013 9.34464C11.013 9.34429 11.0129 9.34388 11.0128 9.34347C10.995 9.26268 10.9983 9.13674 11.0381 8.99779C11.0781 8.85808 11.1419 8.7508 11.1988 8.69387L12.6445 7.24825C12.6443 7.24843 12.6446 7.24802 12.6445 7.24825C13.1276 6.76817 13.3981 6.17451 13.2142 5.60228C13.0305 5.03079 12.466 4.70469 11.7956 4.59294L9.93476 4.28378C9.93464 4.28376 9.93481 4.28379 9.93476 4.28378L8.39936 1.85427ZM8.39936 1.85427C8.39925 1.85415 8.39942 1.8544 8.39936 1.85427V1.85427Z"
        fill="#656782"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.99998 0.776369C6.99929 0.776368 6.9986 0.776367 6.99791 0.776367C6.38844 0.776367 5.90433 1.23303 5.59274 1.85301L4.56566 3.90717L4.56407 3.91038C4.53325 3.9733 4.45958 4.06284 4.34859 4.14514C4.23796 4.22716 4.13064 4.27205 4.06185 4.28389L2.20193 4.59291C1.53104 4.70472 0.967605 5.03122 0.784998 5.60307C0.60252 6.17451 0.871693 6.76712 1.35178 7.2472L2.79845 8.69387C2.85538 8.7508 2.91918 8.85808 2.95918 8.99779C2.99894 9.13674 3.0023 9.26268 2.98449 9.34347L2.98423 9.34464L2.57074 11.1326C2.39833 11.8776 2.45813 12.6173 2.98847 13.0042C3.51848 13.391 4.2416 13.2233 4.90025 12.8324L6.64114 11.8018L6.64225 11.8012C6.72039 11.7561 6.84903 11.7213 6.99998 11.7211V0.776369Z"
        fill="#FFD66D"
      />
      </g>
      <defs>
        <clipPath id="clip0_552_6200">
          <rect width="14" height="14" fill="white"/>
        </clipPath>
      </defs>
    </svg>
    <div v-if="noStar">
      <svg
        class="ms-1 blank-star"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-for="item in noStar"
        :key="`no_${item}`"
      >
        <g clip-path="url(#clip0_552_7928)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.37456 2.24596C6.37461 2.24585 6.3745 2.24608 6.37456 2.24596L5.34901 4.29703C5.23973 4.51919 5.0572 4.70901 4.86974 4.84801C4.68173 4.9874 4.44812 5.10583 4.20772 5.14665L4.20618 5.14691L2.34557 5.45604C2.34564 5.45602 2.34549 5.45605 2.34557 5.45604C1.82663 5.54257 1.65758 5.74695 1.61853 5.86925C1.57934 5.99198 1.59892 6.25688 1.9705 6.62846L3.41717 8.07513C3.60523 8.26319 3.73102 8.51467 3.80039 8.75699C3.86982 8.99954 3.89578 9.27843 3.83805 9.53603L3.8374 9.53889L3.42322 11.3297C3.26898 11.9963 3.425 12.2396 3.50422 12.2974C3.5838 12.3555 3.86401 12.4299 4.45369 12.0799L6.20113 11.0455C6.44374 10.9043 6.7343 10.8461 7.00082 10.8461C7.26688 10.8461 7.55756 10.9042 7.799 11.0472C7.79894 11.0472 7.79906 11.0472 7.799 11.0472L9.54281 12.0795C9.5427 12.0794 9.54293 12.0795 9.54281 12.0795C10.1373 12.4305 10.4172 12.3565 10.4954 12.2995C10.5728 12.2431 10.7288 12.0013 10.574 11.3294L10.1592 9.53603C10.1015 9.27843 10.1275 8.99954 10.1969 8.75699C10.2663 8.51467 10.392 8.26319 10.5801 8.07513L12.0268 6.62846L12.0278 6.62741C12.4018 6.25594 12.4203 5.99175 12.3812 5.87001C12.3418 5.74738 12.1713 5.54268 11.6519 5.45607C11.652 5.45609 11.6519 5.45606 11.6519 5.45607L9.79108 5.1469C9.54824 5.10643 9.31281 4.98845 9.12328 4.84861C8.93451 4.70935 8.75181 4.51934 8.64244 4.29706L7.61606 2.24433C7.3706 1.75081 7.12116 1.65137 6.99791 1.65137C6.87389 1.65137 6.62288 1.75207 6.37456 2.24596ZM8.39936 1.85427C8.09061 1.23381 7.60807 0.776367 6.99791 0.776367C6.38844 0.776367 5.90433 1.23303 5.59274 1.85301L4.56566 3.90717L4.56407 3.91038C4.53325 3.9733 4.45958 4.06284 4.34859 4.14514C4.23796 4.22716 4.13064 4.27205 4.06185 4.28389C4.06205 4.28386 4.06164 4.28393 4.06185 4.28389L2.20193 4.59291C1.53104 4.70472 0.967605 5.03122 0.784998 5.60307C0.60252 6.17451 0.871693 6.76712 1.35178 7.2472L2.79845 8.69387C2.85538 8.7508 2.91918 8.85808 2.95918 8.99779C2.99894 9.13674 3.0023 9.26268 2.98449 9.34347C2.9844 9.34388 2.98432 9.34429 2.98423 9.34464L2.57074 11.1326C2.57073 11.1326 2.57074 11.1325 2.57074 11.1326C2.39833 11.8776 2.45813 12.6173 2.98847 13.0042C3.51848 13.391 4.2416 13.2233 4.90025 12.8324L6.64114 11.8018C6.64155 11.8016 6.6419 11.8014 6.64225 11.8012C6.72053 11.756 6.84951 11.7211 7.00082 11.7211C7.15325 11.7211 7.2796 11.7565 7.3531 11.8001L9.09744 12.8326C9.7569 13.2222 10.4809 13.3929 11.0108 13.0066C11.5415 12.6196 11.5985 11.8786 11.4266 11.1329L11.013 9.34464C11.013 9.34429 11.0129 9.34388 11.0128 9.34347C10.995 9.26268 10.9983 9.13674 11.0381 8.99779C11.0781 8.85808 11.1419 8.7508 11.1988 8.69387L12.6445 7.24825C12.6443 7.24843 12.6446 7.24802 12.6445 7.24825C13.1276 6.76817 13.3981 6.17451 13.2142 5.60228C13.0305 5.03079 12.466 4.70469 11.7956 4.59294L9.93476 4.28378C9.93464 4.28376 9.93481 4.28379 9.93476 4.28378L8.39936 1.85427ZM8.39936 1.85427C8.39925 1.85415 8.39942 1.8544 8.39936 1.85427V1.85427Z"
            fill="#656782"
          />
        </g>
        <defs>
          <clipPath id="clip0_552_7928">
            <rect width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
const MAX_STAR = 5;

export default {
  props: {
    star: {
      type: Number,
    },
  },
  name: 'Star',
  data() {
    return {
      fullStar: 0,
      halfStar: 0,
      noStar: 0,
    };
  },
  watch: {
    star(value) {
      this.setValue(value);
    },
  },
  mounted() {
    this.setValue(this.star);
  },
  computed: {
  },
  methods: {
    setValue(value) {
      if (value && (value <= MAX_STAR)) {
        this.fullStar = Math.floor(value / 1);
        if (value % 1 !== 0) this.halfStar = 1;
        this.noStar = MAX_STAR - this.fullStar - this.halfStar;
      }
    },
  },
};
</script>

<style scoped>
.blank-star {
  margin-top: -4px;
}
</style>
